import { ajax } from "@/plugins/ajax";

export default {
  namespaced: true,
  state: {
    list: [],
    details: [],
    loading: false
  },
  getters: {
    list: state => state.list,
    details: state => state.details,
    loading: state => state.loading
  },
  actions: {
    fetchSingle({ commit }, id) {
      commit("setLoading", true);
      return new Promise((resolve, reject) => {
        ajax
          .get("CMS/api/ProductCollectionQuery/" + id)
          .then(r => {
            commit("setDetails", r.data);
            commit("setLoading", false);
            resolve(r.data);
          })
          .catch(e => reject(e));
      });
    },
    create({ commit, dispatch }, model) {
      return ajax.post("CMS/api/ProductCollection", model);
    },
    remove({ commit, dispatch }, id) {
      return ajax
        .delete(
          "CMS/api/ProductCollection",
          { data: { id: id } },
          { headers: { "Content-Type": "application/json" } }
        )
        .then(r => {});
    },
    update({ commit, dispatch }, model) {
      return ajax.put("CMS/api/ProductCollection", model).then(r => {});
    },
    assignProductToCollection({ commit, dispatch }, model) {
      return ajax.post("CMS/api/ProductForProductCollection", model);
    },
    unassignProductToCollection({ commit, dispatch }, { id, productId }) {
      return new Promise((resolve, reject) => {
        ajax
          .delete(
            "CMS/api/ProductForProductCollection",
            { data: { id: id, productId: productId } },
            { headers: { "Content-Type": "application/json" } }
          )
          .then(r => {
            resolve(r.data);
          })
          .catch(e => {
            reject(e.response.data);
          });
      });
    }
  },
  mutations: {
    setList(state, data) {
      state.list = data;
    },
    setDetails(state, data) {
      state.details = data;
    },
    setLoading(state, value) {
      state.loading = value;
    }
  }
};
